import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from '../../components/hooks/LanguageContext';

const Header = () => {
    const { language } = useLanguage(); // глобальный язык

    const textContent = {
        ru: {
            title: "GEOSURF",
            subtitle: "Точка роста начинается с точки на карте",
            button: "Узнать больше"
        },
        en: {
            title: "GEOSURF",
            subtitle: "Growth starts with a point on the map",
            button: "Learn More"
        }
    };

    const t = textContent[language];

    return (
        <section
            data-bs-version="5.1"
            className="header18 cid-uB0EGy2rVV mbr-fullscreen mbr-parallax-background"
            id="hero-15-uB0EGy2rVV"
        >
            <div className="mbr-overlay" />

            <div className="container-fluid">
                <div className="row">
                    <motion.div
                        className="content-wrap col-12 col-md-6"
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <motion.h1
                            className="mbr-section-title mbr-fonts-style mbr-white mb-4 display-1"
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 1 }}
                        >
                            <strong>{t.title}</strong>
                        </motion.h1>

                        <motion.p
                            className="mbr-fonts-style mbr-text mbr-white mb-4 display-7"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6, duration: 1 }}
                        >
                            {t.subtitle}
                        </motion.p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Header;
